import React from 'react';

function List({ requirement, description }) {
    return (
        <div className="flex justify-center items-center px-6 md:px-10">
            <div className="space-y-6 border-l-2 border-[#ebcab3] border-dashed">
                <div className="relative flex items-center">
                    <i class="fa-solid fa-circle-check absolute -ml-3.5 fa-xl text-[#3d0707]"></i>

                    <div className="ml-6">
                        <h4 className="font-bold text-[#3d0707]">{requirement}</h4>
                        <p className="font-medium">{description}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default List;